import type { $Keys } from 'utility-types'

import { Model } from 'modules/core/lib/mobx-rest'

const UNITS = {
  money: 'money',
  units: 'units',
  time: 'time',
}

export type UnitType = $Keys<typeof UNITS>

export const minutesToDecimalHours = (minutes: number): number => {
  return Number((minutes / 60.0).toFixed(2))
}

export const decimalHoursToFullMinutes = (decimalHours: number) => {
  return Math.round(decimalHours * 60.0)
}

interface ISupplement {
  [key: string]: any
}

class Supplement extends Model<ISupplement> {
  constructor(attr: ISupplement = {}) {
    super(attr)
  }

  static units = UNITS

  static urlRoot() {
    return '/handoffs/supplements'
  }

  get legalEntityId(): string {
    return this.attributes['legal_entity_id']
  }

  getSupplementTypeAmount(supplementTypeId: string): string | null {
    return this.attributes[supplementTypeId]
  }
}

export default Supplement
